module.exports = __webpack_public_path__ + "assets/HotKeys.e1acd60edbd28c29c98bb934a59a86e0.strings";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/en-lproj/HotKeys.strings
// module id = 1032
// module chunks = 0